import { render, staticRenderFns } from "./Concurs.vue?vue&type=template&id=637110cd&scoped=true"
import script from "./Concurs.vue?vue&type=script&lang=js"
export * from "./Concurs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637110cd",
  null
  
)

export default component.exports